<template>
  <div class="container-md plr-0" :key="'user_' + $route.params.id">
    <div class="container-bg p-5 c-pro-wrap">
      <div class="row">
        <div
          class="col-md-4 col-sm-12"
          v-if="!hideUserAttributes.includes('profile_image')"
        >
          <img
            :src="item.profile_image ? item.profile_image : '/assets/icon.jpg'"
            alt=""
            class="img-fluid img-thumbnail float-md-right pro-img"
            style="width: 30%"
          />
        </div>

        <div
          class="col-md-8 col-sm-12"
          v-if="!hideUserAttributes.includes('display_name')"
        >
          <h5 v-if="item.display_name">
            {{ item.display_name }}
          </h5>
        </div>
      </div>
      <form>
        <div class="row">
          <div
            class="form-group col-6"
            v-if="item.firstname && !hideUserAttributes.includes('firstname')"
          >
            <label for="firstname">Voornaam</label>
            <input
              disabled
              id="firstname"
              v-model="item.firstname"
              placeholder="Voornaam"
              class="form-control"
              type="text"
            />
          </div>

          <div
            class="form-group col-6"
            v-if="item.lastname && !hideUserAttributes.includes('lastname')"
          >
            <label for="lastname">Achternaam</label>
            <input
              disabled
              id="lastname"
              v-model="item.lastname"
              placeholder="Achternaam"
              class="form-control"
              type="text"
            />
          </div>

          <div
            class="form-group col-12"
            v-if="item.address && !hideUserAttributes.includes('address')"
          >
            <label for="address">Adres</label>
            <input
              disabled
              id="address"
              v-model="item.address"
              placeholder="Adres"
              class="form-control"
              type="text"
            />
          </div>

          <div
            class="form-group col-6"
            v-if="item.zipcode && !hideUserAttributes.includes('zipcode')"
          >
            <label for="zipcode">Postcode</label>
            <input
              disabled
              id="zipcode"
              v-model="item.zipcode"
              placeholder="Postcode"
              class="form-control"
              type="text"
            />
          </div>

          <div
            class="form-group col-6"
            v-if="item.city && !hideUserAttributes.includes('city')"
          >
            <label for="city">Plaats</label>
            <input
              disabled
              id="city"
              v-model="item.city"
              placeholder="Plaats"
              class="form-control"
              type="text"
            />
          </div>

          <div
            class="form-group col-6"
            v-if="item.mobile && !hideUserAttributes.includes('mobile')"
          >
            <label for="mobile">Telefoonnummer (mobiel)</label>
            <input
              disabled
              id="mobile"
              v-model="item.mobile"
              placeholder="Telefoonnummer (mobiel)"
              class="form-control"
              type="tel"
              pattern="[0-9]{10}"
            />
          </div>

          <div
            class="form-group col-6"
            v-if="item.phone && !hideUserAttributes.includes('phone')"
          >
            <label for="phone">Telefoonnummer</label>
            <input
              disabled
              id="phone"
              v-model="item.phone"
              placeholder="Telefoonnummer"
              class="form-control"
              type="tel"
              pattern="[0-9]{10}"
            />
          </div>

          <div
            class="form-group col-6"
            v-if="
              item.date_of_birth &&
                !hideUserAttributes.includes('date_of_birth')
            "
          >
            <label for="date_of_birth">Geboortedatum</label>
            <input
              disabled
              id="date_of_birth"
              v-model="item.date_of_birth"
              placeholder="Geboortedatum"
              class="form-control"
              type="date"
            />
          </div>

          <div
            class="form-group col-6"
            v-if="item.gender && !hideUserAttributes.includes('gender')"
          >
            <label for="gender">Geslacht</label>
            <select
              class="form-control"
              disabled
              id="gender"
              v-model="item.gender"
              placeholder="Geslacht"
            >
              <option value="">-- Maak een keuze --</option>
              <option value="-1">Vrouw</option>
              <option value="0">Anders</option>
              <option value="1">Man</option>
            </select>
          </div>

          <div
            class="form-group col-6"
            v-if="item.website && !hideUserAttributes.includes('website')"
          >
            <label for="website">website</label>
            <input
              disabled
              id="website"
              v-model="item.website"
              placeholder="Website"
              class="form-control"
              type="text"
            />
          </div>

          <div
            class="form-group col-12"
            v-if="item.about_me && !hideUserAttributes.includes('about_me')"
          >
            <label for="about_me">Over mij</label>
            <div
              style="background-color: #e9ecef; padding: 5px"
              v-html="item.about_me"
            ></div>
          </div>

          <hr />

          <table class="table table-responsive-lg">
            <thead>
              <tr>
                <th>Commissies</th>
                <th>Groepen</th>
                <th>Taken</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <li
                    v-for="(group, index) in item.user_committees"
                    :key="index"
                  >
                    {{ group.title }}
                  </li>
                </td>
                <td>
                  <li v-for="(group, index) in item.groups" :key="index">
                    {{ group.title }}
                  </li>
                </td>
                <td>
                  <li v-for="(group, index) in item.tasks" :key="index">
                    {{ group.title }}
                  </li>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <router-link :to="'/profile/' + $route.params.id + '/view'">
          <button class="btn btn-dark m-3">Bekijk mijn profielpagina</button>
        </router-link>
      </form>
    </div>
  </div>
</template>
<script>
import moment from "moment";

export default {
  name: "publicProfile",
  data() {
    return {
      privacy_settings: {
        display_name: true,
        profile_image: true,
        firstname: false,
        lastname: false,
        address: false,
        zipcode: false,
        city: false,
        phone: false,
        mobile: false,
        website: false,
        gender: false,
        date_of_birth: false,
        about_me: false,
      },
      item: {},
      loading: false,
      hideUserAttributes: process.env.VUE_APP_HIDE_USER_ATTRIBUTES.split(","),
    };
  },
  filters: {
    formatDate(value) {
      return moment(new Date(value)).format("DD-MM-YYYY");
    },
  },

  mounted() {
    this.$store
      .dispatch(
        "get",
        "api/v1/user/" + this.$route.params.id + "/public-profile"
      )
      .then(({ data }) => {
        this.item = { ...data.data };
        console.log(this.item);
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
